function computeAvgConfidence(results) {
    const scores = [];
    for (const row of results || []) {
        if (row.status !== 'done') continue;
        scores.push(2);
    }
    if (scores.length === 0) return '—';
    const avg = scores.reduce((a, b) => a + b, 0) / scores.length;
    if (avg >= 2.5) return 'High';
    if (avg >= 1.5) return 'Medium';
    return 'Low';
}

export default function Step5Summary({ jobStatus, onStartOver, onOpenMyProperties }) {
    const enrichedOk = jobStatus?.complete ?? 0;
    const failed = jobStatus?.failed ?? 0;
    const needsReview = jobStatus?.needsReview ?? 0;
    const avgConfidence = computeAvgConfidence(jobStatus?.results);

    return (
        <div className="bulk-state">
            <div className="bulk-state-title">Complete</div>
            <h3>Enrichment finished</h3>
            <div className="preflight-stats">
                <div className="stat-tile success">
                    <div className="stat-label">Enriched OK</div>
                    <div className="stat-value">{enrichedOk}</div>
                </div>
                <div className="stat-tile danger">
                    <div className="stat-label">Failed</div>
                    <div className="stat-value">{failed}</div>
                </div>
                <div className="stat-tile warn">
                    <div className="stat-label">Need your input</div>
                    <div className="stat-value">{needsReview}</div>
                </div>
                <div className="stat-tile">
                    <div className="stat-label">Avg confidence</div>
                    <div className="stat-value">{avgConfidence}</div>
                </div>
            </div>
            <p className="bulk-state-sub" style={{ marginBottom: 6 }}>
                <strong style={{ color: 'var(--text-primary)' }}>
                    {enrichedOk + needsReview} propert{(enrichedOk + needsReview) === 1 ? 'y' : 'ies'} saved as drafts in My Properties.
                </strong>
            </p>
            <p className="bulk-state-sub" style={{ fontSize: 12.5, marginBottom: 8 }}>
                Bulk no longer auto-submits to Ops. Open My Properties to add photos, confirm geofences, and review any medium-confidence AI fields before submitting — individually or via the new &ldquo;Bulk Submit completed&rdquo; action.
            </p>
            <div className="bulk-actions split">
                <button type="button" className="btn btn-secondary" onClick={onStartOver}>
                    ← Start over
                </button>
                <div style={{ display: 'flex', gap: 10 }}>
                    <button type="button" className="btn btn-primary" onClick={onOpenMyProperties}>
                        Open My Properties to complete →
                    </button>
                </div>
            </div>
        </div>
    );
}
